<template>
  <!-- table区域-begin -->
  <div class="table-container">
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      class="j-table-force-nowrap"
      :scroll="{ x: true }"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="htmlSlot" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <template slot="imgSlot" slot-scope="text">
        <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
        <img
          v-else
          :src="getImgView(text)"
          height="25px"
          alt=""
          style="max-width: 80px; font-size: 12px; font-style: italic"
        />
      </template>
      <template slot="fileSlot" slot-scope="text">
        <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
        <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
          下载
        </a-button>
      </template>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>

        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>
  </div>
</template>


<script>
import Vue from 'vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default Vue.extend({
  name: 'AllPlanList',
  mixins: [JeecgListMixin],
  data() {
    return {
      model: {},
      // 表头
      columns: [
        {
          title: '用户',
          align: 'center',
          dataIndex: 'createByDictText',
        },
        {
          title: '工作计划',
          align: 'center',
          dataIndex: 'content',
        },
        {
          title: '权重',
          align: 'center',
          dataIndex: 'weight',
        },
        {
          title: '虚线汇报对象',
          align: 'center',
          dataIndex: 'facilitatorsText',
        },
        {
          title: '汇报对象',
          align: 'center',
          dataIndex: 'reporterText',
        },
      ],
      url: {
        list: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/listOkrPlanReviseByUser`,
      },
    }
  },
  methods: {
    handleQuery(filters) {
      this.filters = filters
      this.loadData()
    },
  },
})
</script>

<style lang="less" scoped>
@import '~@assets/less/common.less';

.table-container /deep/td {
  white-space: pre-wrap;
}
</style>
